"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var defaultProps_1 = __importDefault(require("./defaultProps"));
var makeInfoPanelStyling_1 = __importDefault(require("./makeInfoPanelStyling"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var InfoPanel = function (_a) {
    var title = _a.title, children = _a.children, Icon = _a.Icon;
    var styles = (0, makeInfoPanelStyling_1.default)();
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, { css: styles.panel, children: [Icon && (0, jsx_runtime_1.jsx)(Box_1.default, { css: styles.iconBox, children: Icon }), (0, jsx_runtime_1.jsxs)(Box_1.default, { css: styles.textBox, children: [title && ((0, jsx_runtime_1.jsx)(Typography_1.default, { component: 'h5', css: styles.title, children: title })), (0, jsx_runtime_1.jsx)(Typography_1.default, { component: 'span', css: styles.children, children: children })] })] }));
};
InfoPanel.defaultProps = defaultProps_1.default;
exports.default = InfoPanel;
//# sourceMappingURL=InfoPanel.js.map